module.exports = __webpack_public_path__ + "static/media/LUNA.104140d6.svg";